const PROVIDER_DISPLAY_NAMES = {
  "OktoPay.Cash": "Okto",
  PaySafeCard: "Paysafe",
  SafeCharge: "Nuvei",
  Trust: "Trust",
  "Viva.Card": "Viva"
};

const formatProviderId = (providerId) => {
  if (!providerId) {
    return "";
  }

  return (
    PROVIDER_DISPLAY_NAMES[providerId] ||
    providerId
      .replace(/[._-]+/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (character) => character.toUpperCase())
  );
};

export const getCardProviderTags = (card) => {
  if (!Array.isArray(card?.tokens)) {
    return [];
  }

  const seenProviders = new Set();

  return card.tokens
    .map((token) => {
      const providerId =
        token?.providerId ||
        token?.providerName ||
        token?.providerDisplayName ||
        token?.displayName ||
        token?.name;
      const label =
        token?.providerName ||
        token?.providerDisplayName ||
        token?.displayName ||
        token?.name ||
        formatProviderId(providerId);

      return {
        id: providerId || label,
        label
      };
    })
    .filter((provider) => {
      if (!provider.id || seenProviders.has(provider.id)) {
        return false;
      }

      seenProviders.add(provider.id);
      return true;
    });
};
